import { render, staticRenderFns } from "./OurCompany.vue?vue&type=template&id=421730c0&"
import script from "./OurCompany.vue?vue&type=script&lang=js&"
export * from "./OurCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports